<template>
  <div>
    <h1>Create User</h1>
    <form @submit.prevent="submitForm">
      <div>
        <label for="email">Email:</label>
        <input type="email" id="email" v-model="user.email" required />
      </div>
      <div>
        <label for="password">Password:</label>
        <input type="password" id="password" v-model="user.password" required />
      </div>
      <div>
        <label for="role">Role:</label>
        <select id="role" v-model="user.user_role" required>
          <option value="1">Admin</option>
          <option value="1">User</option>
        </select>
      </div>
      <div>
        <label for="company">Company:</label>
        <select id="company" v-model="user.company_id" required>
          <option value="1">RFIDS</option>
          <option value="2">AVINOR</option>
        </select>
      </div>
      <button type="submit">Create</button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        email: '',
        password: '',
        user_role: null,
        company_id: null
      }
    }
  },
  methods: {
    async submitForm() {
      try {
        const response = await fetch('https://bachelor.rfid-solutions.no/api/new-user', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.user)
        })
        if (response.ok) {
          this.$router.push('/database')
        } else {
          console.error('Failed to create user:', response)
        }
      } catch (error) {
        console.error('An error occurred during user creation:', error)
      }
    }
  }
}
</script>

<style scoped>
/* Add your custom styles here */
</style>
